import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'services/axiosBaseQuery'
import {
  AIInstructorRequest,
  AIReportRequest,
  AnomalyAnalysisResponse,
  GetEmployeePerformanceResponse,
  GetRouteAssignmentAnalysisResponse,
  GetVehiclePerformanceResponse,
  GetWasteAmountsByRegionResponse,
  ScheduleInstructorResponse,
  SendFeedbackRequest,
  SendFeedbackResponse,
} from './types'

export const aiApi = createApi({
  reducerPath: 'aiApi',
  tagTypes: [
    'EmployeePerformance',
    'AnomalyAnalysis',
    'VehiclePerformance',
    'WasteAmounts',
    'RouteAssignment',
  ],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_AI_URL}/v1`,
    defaultHeaders: {
      'X-Environment': 'prod',
    },
  }),
  endpoints: (builder) => ({
    getEmployeePerformance: builder.query<GetEmployeePerformanceResponse, AIReportRequest>({
      query: ({ clientId }) => ({
        url: `/reports/employee_performance/${clientId}`,
        method: 'GET',
      }),
      providesTags: ['EmployeePerformance'],
    }),
    getAnomalyAnalysis: builder.query<AnomalyAnalysisResponse, AIReportRequest>({
      query: ({ clientId }) => ({
        url: `/reports/service_point_anomaly/${clientId}`,
        method: 'GET',
      }),
      providesTags: ['AnomalyAnalysis'],
    }),
    getEmployeeVehiclePerformance: builder.query<GetVehiclePerformanceResponse, AIReportRequest>({
      query: ({ clientId }) => ({
        url: `/reports/vehicle_performance/${clientId}`,
        method: 'GET',
      }),
      providesTags: ['VehiclePerformance'],
    }),
    getWasteAmountsByRegion: builder.query<GetWasteAmountsByRegionResponse, AIReportRequest>({
      query: ({ clientId }) => ({
        url: `/reports/waste_amount_by_region/${clientId}`,
        method: 'GET',
      }),
      providesTags: ['WasteAmounts'],
    }),
    getRouteAssignmentAnalysis: builder.query<GetRouteAssignmentAnalysisResponse, AIReportRequest>({
      query: ({ clientId }) => ({
        url: `/reports/region_task_done_ratio/${clientId}`,
        method: 'GET',
      }),
      providesTags: ['RouteAssignment'],
    }),
    getSchedule: builder.mutation<ScheduleInstructorResponse, AIInstructorRequest>({
      query: (data) => ({
        url: `/instructor/schedule`,
        method: 'POST',
        data,
      }),
    }),
    sendFeedback: builder.mutation<SendFeedbackResponse, SendFeedbackRequest>({
      query: (data) => ({
        url: `/feedback`,
        method: 'POST',
        data,
      }),
    }),
  }),
})
